import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

export interface HighwayUnpaidEditConfirmBottomSheetProps {
  beforeLicensePlate: string;
  afterLicensePlate: string;
}

function HighwayUnpaidEditConfirmBottomSheet({beforeLicensePlate, afterLicensePlate}: HighwayUnpaidEditConfirmBottomSheetProps) {
  const {t} = useInferableTranslation();

  return (
    <div className="bottom_sheet">
      <div className="bottom_sheet_header">
        <h2
          id="bottomSheetTitle"
          className="bottom_sheet_title"
        >
          {t('T20387')}
        </h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label="close"
          onClick={() => window.bottomSheetClose(false)}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <strong
            className="bottom_sheet_title_sub"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T20388')}
          </strong>

          <div className="bottom_sheet_container">
            <dl className="vehicle_info type_gray">
              <div className="vehicle_item">
                <dt className="info_title">{t('T20389')} :</dt>
                <dd className="info_text">{beforeLicensePlate}</dd>
              </div>
              <div className="vehicle_item">
                <dt className="info_title">{t('T20390')} :</dt>
                <dd className="info_text">{afterLicensePlate}</dd>
              </div>
            </dl>
          </div>
        </div>

        <div className="bottom_sheet_footer">
          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => window.bottomSheetClose(true)}
          >
            {t('T20391')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default HighwayUnpaidEditConfirmBottomSheet;
